import * as React from "react";
import "./style.css";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Modal,
} from "@mui/material";
import FacilityETLs from "./FacilityETLs";
import {
    fetchCurrentQuotas,
    fetchFacilityETLs,
} from "../../../redux/models/integrations/Action";

export const Quotas = ({loggedInUser, integrationAccount, integrationNamespace, facility, etls, manageQuotas, setManageQuotas}) => {
    const [formState, setFormState] = useState({
        is_active: facility.is_active,
        inception_date: facility.inception_date,
        email: facility.email,
    });
    const dispatch = useDispatch();
    const [facilityETLs, setFacilityETLs] = useState([]);
    const [currentUsage, setCurrentUsage] = useState(() => []);

    useEffect(() => {
        const abortController = new AbortController();
        Promise.all([
            dispatch(fetchFacilityETLs(integrationNamespace, facility.id, {}, abortController)),
            dispatch(fetchCurrentQuotas({
                namespace: integrationNamespace,
                params: {
                    organization_id: integrationAccount.organization_id,
                    facility_id: facility.id
                },
                abortController
            }))
        ]).then(([fetchedFacilityETLs, fetchedQuotaUsage]) => {
            setFacilityETLs(fetchedFacilityETLs);
            setCurrentUsage((state) => {
                return [...state, ...fetchedQuotaUsage];
            });
        }).catch(err => {
            console.error(err);
        });
        return () => {
            abortController.abort();
        };
    }, [facility.id]);

    return <Modal
        open={manageQuotas[facility.id]}
        onClose={() => {
            setManageQuotas({...manageQuotas, [facility.id]: false});
        }}
        className={"quota-management-modal"}
    >
        <FacilityETLs
            integrationAccount={integrationAccount}
            loggedInUser={loggedInUser}
            facility={facility}
            integrationNamespace={integrationNamespace}
            etls={etls}
            facilityETLs={facilityETLs}
            currentUsage={currentUsage}
            isActive={formState.is_active || facility.is_active}
        />
    </Modal>;
};


export default Quotas;